export  default {
    bind(el,binding){
        let ariaEls=el.querySelectorAll(".el-radio__original");
        ariaEls.forEach(item=>{
            item.removeAttribute("aria-hidden")
        })
    }
}